var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04125 5.48145C7.10125 6.37145 7.25125 7.24145 7.49125 8.07145L6.29125 9.27145C5.88125 8.07145 5.62125 6.80145 5.53125 5.48145H7.04125ZM16.8992 17.5015C17.7492 17.7415 18.6192 17.8915 19.4992 17.9515V19.4415C18.1792 19.3515 16.9092 19.0915 15.6992 18.6915L16.8992 17.5015ZM8 3.48145H4.5C3.95 3.48145 3.5 3.93145 3.5 4.48145C3.5 13.8714 11.11 21.4814 20.5 21.4814C21.05 21.4814 21.5 21.0314 21.5 20.4814V16.9914C21.5 16.4414 21.05 15.9914 20.5 15.9914C19.26 15.9914 18.05 15.7914 16.93 15.4214C16.83 15.3814 16.72 15.3714 16.62 15.3714C16.36 15.3714 16.11 15.4714 15.91 15.6614L13.71 17.8614C10.88 16.4114 8.56 14.1014 7.12 11.2714L9.32 9.07145C9.6 8.79145 9.68 8.40145 9.57 8.05145C9.2 6.93145 9 5.73145 9 4.48145C9 3.93145 8.55 3.48145 8 3.48145Z",
    fill: "#CF9F1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.6485a1c4bf563b2d2d1f07d43aad2a5f.svg";
export { ForwardRef as ReactComponent };